import React from "react"
import "./numbers.scss"

const Numbers = ({ sectionTitle, data, contrast, theme }) => {
  return (
    <section
      className={`section-padding numbers ${contrast && "numbers--contrast"}`}
    >
      <div className={theme ? `centre ${theme}` : "centre"}>
        {sectionTitle && (
          <h2 dangerouslySetInnerHTML={{ __html: sectionTitle }} />
        )}
        {sectionTitle && <hr />}
        <div className="numbers__grid">
          {data.map(({ value, label }, idx) => (
            <div key={idx}>
              <h2 className="highlight">{value}</h2>
              <h3>{label}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Numbers
